<template>
  <div class="panel-display-container" style="display: flex; flex-wrap: wrap;">
    <div v-for="n in getTotalPanels(wallTypes)" :key="'complete-panel-' + n"
      style="background-color: #C79467; margin: 5px;" :style="{ width: width / 2 + 'px', height: length / 2 + 'px' }">
    </div>
    <div v-for="(portion, index) in pannelPortions" :key="'portion-' + index"
      style="background-color: #70451F; margin: 5px;"
      :style="{ width: width / 2 + 'px', height: portion.value * length / 2 + 'px' }">
    </div>
  </div>
</template>

<script setup>


defineProps({
  getTotalPanels: Function,
  wallTypes: Array,
  pannelPortions: Array,
  width: Number,
  length: Number,
});
</script>

<style scoped>
@import '@/assets/styles/components/panelCountEstimator/PanelizationPropositionPanelDisplay.css';
</style>